import React from 'react';
import Select from 'react-select';
import { toEnglish, toPersian } from 'persian';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import priceFormat from '../../service/showPriceFormat';


const PaymentCard = ({ item, index, setPayment }) => {

    const paymentTypes = [
        { label: toPersian('نقدی'), value: 'cash' },
        { label: toPersian('چک'), value: 'check' },
    ]

    const digits = persian_fa.digits;

    const handlePaymentType = (selectedOption) => {
        setPayment(prev => {
            let allItems = [...prev];
            allItems[index].type = selectedOption.value;
            return [...allItems]
        })
    }
    const handlePaymentPrice = (price) => {
        setPayment(prev => {
            let allItems = [...prev];
            allItems[index].price = price;
            return [...allItems]
        })
    }
    const handlePaymentDate = (dateTimeStamp) => {
        setPayment(prev => {
            let allItems = [...prev];
            allItems[index].dateTimeStamp = dateTimeStamp;
            return [...allItems]
        })
    }
    const handlePaymentDone = (checked) => {
        setPayment(prev => {
            let allItems = [...prev];
            allItems[index].done = checked;
            return [...allItems]
        })
    }

    return (
        <div className='border mx-auto py-2 mb-3 shadow-sm rounded' style={{ width: '300px' }}>
            <section className="d-flex justify-content-center align-items-center rtl" style={{ fontSize: '.8rem' }}>
                <Select
                    placeholder="نوع پرداخت"
                    value={{ value: item.type, label: item.type === 'check' ? 'چک' : item.type === 'cash' ? 'نقدی' :  "نوع پرداخت"}}
                    onChange={selectedOption => handlePaymentType(selectedOption)}
                    options={paymentTypes}
                    isClearable={false}
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            marginTop: "0px",
                            marginLeft: '5px',
                            width: "140px",
                            boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                : "none",
                            borderColor: state.isFocused
                                ? "#80bdff"
                                : baseStyles.borderColor,
                        }),
                        menuList: (baseStyles, state) => ({
                            ...baseStyles,
                            maxHeight: "200px",
                            textAlign: "right",
                        }),
                    }}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary25: "#ddd",
                            primary: "rgb(40, 167, 69)",
                        },
                    })}
                    isRtl={true}
                    noOptionsMessage={() => "موردی وجود ندارد"}
                />
                <div className="payment-customer-calendar">
                    <DatePicker
                        format="YYYY/MM/DD"
                        placeholder='تاریخ پرداخت'
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="top-center"
                        value={item.dateTimeStamp}
                        // id="paymentDate_input"
                        onChange={(date, { input, isTyping }) => {
                            try {
                                if (!isTyping) return handlePaymentDate(Number(date)); // user selects the date from the calendar and no needs for validation.

                                let value = input.value;
                                for (let digit of digits) {
                                    value = value.replace(
                                        new RegExp(digit, "g"),
                                        digits.indexOf(digit)
                                    );
                                }

                                const strings = value.split("/");
                                const numbers = strings.map(Number);
                                const [year, month, day] = numbers;
                                if (input.value && numbers.some((number) => isNaN(number))) {
                                    return false; //in case user enter something other than digits
                                }
                                if (String(year).length > 4) return false; //month < 0 in case user want to type 01
                                if (month > 12 || month < 0) return false; //month < 0 in case user want to type 01
                                if (day < 0 || (date && day > date.day)) return false;
                                if (strings.some((val) => val.startsWith("00"))) return false;

                                handlePaymentDate(Number(date));
                            } catch (err) {
                                return false
                            }
                        }}
                    />
                </div>
            </section>
            <div className='d-flex justify-content-center  align-items-center rtl my-2' style={{ fontSize: '.9rem' }}>
                <div>
                    <input
                        type="text"
                        autoComplete='off'
                        className="form-control"
                        style={{ textAlign: 'left', direction: "ltr", width: '140px', height: '38px', fontSize: '.8rem', marginLeft: '5px' }}
                        placeholder='مبلغ (تومان)'
                        value={priceFormat(toEnglish(item.price))}
                        onChange={(e) => handlePaymentPrice(Number(toEnglish(e.target.value.replace(/,/g, ''))))}
                    />
                </div>
                <div className=''>
                    <div className='special-checkbox'>
                        <label className="green-checkbox">
                            <input
                                type="checkbox"
                                className="fill-control-input"
                                id={`checkExample1`}
                                checked={item.done}
                                onChange={e => handlePaymentDone(e.target.checked)}
                            />
                            <span className="text-dark ml-3">پرداخت شده</span>
                            <span className="fill-control-indicator "></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentCard;